import momentTimezone from 'moment-timezone';

export default () => momentTimezone.tz.guess();
